module.exports = __webpack_public_path__ + "img/partner17.200a8c75.png";